import React, { useEffect, useState } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "./AddTrack.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Breadcrumb from "react-bootstrap/Breadcrumb"; // Import Breadcrumb component
import ThinFooter from "../Footer/ThinFooter";
import ContentWrapper from "../Atomics/ContentWrapper/ContentWrapper";
import axiosInstance from "../../axiosInstance";
import toast, { Toaster } from "react-hot-toast";
import { useHistory } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";

const RaceTrackMap = () => {
  const history = useHistory();
  const [map, setMap] = useState(null);
  const [marker, setMarker] = useState(null);
  const [loading, setLoading] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [trackDetails, setTrackDetails] = useState({
    name: "",
    address: "",
    image: "",
  });

  useEffect(() => {
    const initializeMap = () => {
      const mapInstance = L.map("map", {
        center: [39.8283, -98.5795], // Default center (USA)
        zoom: 4,
      });

      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }).addTo(mapInstance);

      setMap(mapInstance);
    };

    initializeMap();
  }, []);

  const updateMapLocation = async (lat, lon) => {
    const latLng = [parseFloat(lat), parseFloat(lon)];

    if (map) {
      map.setView(latLng, 15); // Center the map
      // if (marker) {
      //   marker.setLatLng(latLng); // Update existing marker
      // } else {
      //   const newMarker = L.marker(latLng).addTo(map); // Add new marker
      //   setMarker(newMarker);
      // }
    }
  };

  const handleAddressChange = async (e) => {
    const address = e.target.value;
    setTrackDetails((prevDetails) => ({
      ...prevDetails,
      address,
    }));

    if (address.trim()) {
      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(
            address
          )}&format=json&addressdetails=1&limit=5`
        );
        const data = await response.json();

        if (data && data.length > 0) {
          setSuggestions(data);
        } else {
          setSuggestions([]);
        }
      } catch (error) {
        console.error("Error fetching location data:", error);
        setSuggestions([]);
      }
    } else {
      setSuggestions([]);
    }
  };

  const handleSuggestionClick = (suggestion) => {
    const { display_name, lat, lon } = suggestion;

    setTrackDetails((prevDetails) => ({
      ...prevDetails,
      address: display_name,
    }));
    setSuggestions([]);
    updateMapLocation(lat, lon);
  };

  const handleImageUpload = async (file) => {
    if (!file) return;

    const maxSizeInKB = 500; // 500KB
    const fileSizeInKB = file.size / 1024;

    if (fileSizeInKB > maxSizeInKB) {
      toast.error(`File size exceeds the maximum limit of ${maxSizeInKB}KB.`);
      return;
    }

    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("image", file);

      const response = await fetch("https://beta.autotrak.ai/api/aws/upload", {
        method: "POST",
        body: formData,
      });

      const data = await response.json();
      const s3Url = data.data.url;

      setTrackDetails((prevDetails) => ({ ...prevDetails, image: s3Url }));
    } catch (error) {
      toast.error("Failed to upload this image");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveImage = () => {
    setImageLoaded(false);
    setTrackDetails((prevDetails) => ({ ...prevDetails, image: "" }));
  };

  const handleSaveChanges = async () => {
    if (!trackDetails.name || !trackDetails.address) {
      toast.error("Please fill out all required fields.");
      return;
    }

    const trackData = {
      trackName: trackDetails.name,
      mapImage: trackDetails.image,
      address: trackDetails.address,
    };

    try {
      const token = localStorage.getItem("token");
      await axiosInstance.post("/track/add", trackData, {
        headers: {
          Authorization: token,
        },
      });

      toast.success("Track saved successfully!");
      handleMoveToTracks();
    } catch (error) {
      console.error("Failed to save track", error);
      toast.error("Error saving track. Please try again.");
    }
  };

  const handleMoveToTracks = () => {
    history.push("/track");
  };

  return (
    <>
      <ContentWrapper>
        <Container fluid className="pb-0" id="trckfrm">
          {/* Breadcrumbs Section */}
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/track">Tracks</Breadcrumb.Item>
            <Breadcrumb.Item active>Add Track</Breadcrumb.Item>
          </Breadcrumb>

          <Row className="add_trck_form">
            {/* Track Name Field */}
            <Col xs={12} md={5} className="form-section">
              <div className="form-group">
                <label htmlFor="trackName">Track Name</label>
                <input
                  type="text"
                  className="form-control"
                  id="trackName" autocomplete="off"
                  placeholder="Enter Track Name"
                  value={trackDetails.name}
                  onChange={(e) =>
                    setTrackDetails({ ...trackDetails, name: e.target.value })
                  }
                />
              </div>
            </Col>

            {/* Image Upload Field */}
            <Col xs={12} md={5}>
              <div className="form-group">
                <label htmlFor="image">Map Image</label>
                {loading ? (
                  <Spinner animation="border" role="status" />
                ) : trackDetails.image ? (
                  <div style={{ position: "relative", display: "inline-block" }}>
                    <img
                      style={{ width: "100%", height: "200px" }}
                      src={trackDetails.image}
                      alt="Uploaded preview"
                      onLoad={() => setImageLoaded(true)}
                    />
                    {imageLoaded && (
                      <button
                        onClick={handleRemoveImage}
                        style={{
                          position: "absolute",
                          top: "0",
                          right: "0",
                          background: "none",
                          border: "none",
                          cursor: "pointer",
                          color: "red",
                        }}
                        aria-label="Remove Image"
                      >
                        <i className="fa-solid fa-2x fa-xmark"></i>
                      </button>
                    )}
                  </div>
                ) : (
                  <input
                    type="file"
                    className="form-control"
                    id="imageUpload" 
                    accept="image/*"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file) {
                        handleImageUpload(file);
                      }
                    }}
                    disabled={loading}
                  />
                )}
              </div>
            </Col>
          </Row>

          {/* Address Field */}
          <Row>
            <Col xs={12} md={5}>
              <div className="form-group position-relative">
                <label htmlFor="address">Address</label>
                <input
                  type="text"
                  className="form-control"
                  id="address" autocomplete="off"
                  placeholder="Enter Track Address"
                  value={trackDetails.address}
                  onChange={handleAddressChange}
                />
                {suggestions.length > 0 && (
                  <ul className="suggestions-list">
                    {suggestions.map((suggestion, index) => (
                      <li
                        key={index}
                        onClick={() => handleSuggestionClick(suggestion)}
                      >
                        {suggestion.display_name}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </Col>
          </Row>

          {/* Map */}
          <Row className="mt-3">
            <Col xs={12}>
              <div id="map" style={{ height: "700px", width: "100%" }}></div>
            </Col>
          </Row>

          {/* Save Changes Button */}
          <Row className="mt-3" id="sc_btn">
            <Col xs={12} className="text-right">
              <button
                onClick={handleSaveChanges}
                className="btn btn-primary sv_btn"
              >
                Save Changes
              </button>
            </Col>
          </Row>
        </Container>

        <ThinFooter />
      </ContentWrapper>
      <Toaster />
    </>
  );
};

export default RaceTrackMap;
